import FormElementPicker from '@/components/FormElementPicker/FormElementPicker';

export default FormElementPicker;
